import { render } from "./SectionBorder.vue?vue&type=template&id=4a04b0aa"
const script = {}
script.render = render

export default script